<div class="bank-account-card">
  <div ngbAccordion>
    <div class="d-flex align-items-center">
      <div class="d-flex gap-2 align-items-center">
        <app-radio-button-input
          *ngIf="!radioHidden"
          formControlName="accountId"
          [value]="bankAccount.id"
          [name]="'accountId'"
          [controlId]="'accountId' + generatedRandomId"
          (selectionChange)="selected.emit()" />
        <label class="bank-account-name" [for]="'accountId' + generatedRandomId">
          {{ bankAccount.nickname }} - {{ bankAccount.id | leadingZero : 8 }}
        </label>
      </div>
      <button
        class="no-style-button accordion-header-button d-flex flex-grow-1 justify-content-end"
        (click)="toggleAccordionExpand()">
        <div>
          <img
            class="chevron"
            [src]="'assets/icons/grey/Chevron Up.svg'"
            [class.expanded]="accordionIsExpanded$ | async"
            [class.collapsed]="!(accordionIsExpanded$ | async)"
            alt="Toggle accordion"
            i18n-alt />
        </div>
      </button>
    </div>
    <div class="d-flex flex-column gap-3" ngbAccordionItem [collapsed]="!(accordionIsExpanded$ | async)">
      <div ngbAccordionCollapse>
        <div class="bank-info-grid">
          <app-review-entry label="Institution Number" i18n-label [value]="bankAccount.institutionNumber" />
          <app-review-entry label="Transit Number" i18n-label [value]="bankAccount.transitNumber" />
          <app-review-entry label="Account Number" i18n-label [value]="bankAccount.accountNumber" />
        </div>
        <div i18n class="date-added">Date Added: {{ bankAccount.createdDate | date : 'MMM d, y' }}</div>
      </div>
    </div>
  </div>
</div>
